import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Book } from 'lucide-react';
const tomos = [{
  icon: '📘',
  title: 'Tomo 1 — La Biblia del Espacio Reducido',
  subtitle: 'Fundamentos y primer proyecto',
  items: ['Fundamentos del mueble plegable', 'Materiales y placas para el mercado argentino', 'Los 6 herrajes fundamentales', 'Herramientas mínimas para empezar', 'Proyecto completo: Repisa plegable de pared paso a paso', 'Los 10 errores críticos y cómo evitarlos']
}, {
  icon: '📗',
  title: 'Tomo 2 — Mesas y Escritorios Rebatibles',
  subtitle: '5 modelos con planos completos',
  items: ['Los 5 sistemas de plegado para mesas', 'Planos y lista de corte de 5 modelos', 'Proyecto estrella: Mesa rebatible con pistón neumático', 'Escritorio home office plegable', 'Estrategia de precios para el mercado argentino']
}, {
  icon: '📙',
  title: 'Tomo 3 — Estanterías e Islas Móviles',
  subtitle: 'Sistemas de almacenamiento modular',
  items: ['Ruedas industriales: selección y montaje correcto', '5 modelos de estantería modular con planos', 'Proyecto estrella: Isla de cocina transformable', 'Iluminación LED integrada en muebles móviles', 'Cómo vender sistemas modulares a empresas']
}, {
  icon: '📕',
  title: 'Tomo 4 — Dormitorios Inteligentes',
  subtitle: 'Camas Murphy y sistemas rebatibles',
  items: ['Cálculo del mecanismo Murphy paso a paso', 'Planos de 5 modelos de camas rebatibles', 'Proyecto estrella: Cama Murphy con escritorio integrado', 'LED de cabecera en sistema plegable', 'Cómo cobrar una Cama Murphy y por qué vale más de $1.000.000 ARS']
}, {
  icon: '📓',
  title: 'Tomo 5 — Sillería y Bancos Plegables',
  subtitle: 'Ergonomía y resistencia de carga',
  items: ['Los 4 mecanismos de bloqueo para sillas', '5 modelos de sillas y bancos con planos', 'Proyecto estrella: Silla ergonómica de madera maciza', 'Tapizado e integración de materiales textiles', 'Cómo vender sets a restaurantes y eventos']
}, {
  icon: '📔',
  title: 'Tomo 6 — El Taller Plegable',
  subtitle: 'Bancos de trabajo que desaparecen en la pared',
  items: ['Sistemas de anclaje para cargas extremas y vibración', '5 modelos de bancos de trabajo con planos', 'Proyecto estrella: Estación completa con tornillo de banco integrado', 'Iluminación profesional LED de taller', 'Cómo vender el concepto de taller plegable al mercado urbano']
}];
const features = ['Planos de corte con medidas reales (no nominales)', 'Lista de herrajes por proyecto con precios de referencia ARS 2024', 'Checklist de armado paso a paso', 'Control de calidad antes de instalar herrajes caros', 'Material original Super Combo Carpintería Plegable PRO™', '5 modelos completos por tomo con lista de corte', 'Protocolos de instalación segura por tipo de pared', 'Guías técnicas de herrajes con capacidades de carga reales', '100% adaptado al carpintero emprendedor argentino'];
export function ProductTomos() {
  return <section className="py-20 bg-cream" data-id="element-299">
      <div className="container mx-auto px-4" data-id="element-300">
        <div className="text-center max-w-4xl mx-auto mb-16" data-id="element-301">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-4" data-id="element-302">
            <span className="text-wood-light font-bold tracking-wider uppercase text-sm" data-id="element-303">
              Sistema N°1 para Carpinteros Emprendedores en Argentina
            </span>
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-black text-wood-dark mb-6" data-id="element-304">
            SUPER COMBO™ <br data-id="element-305" />
            <span className="text-amber-dark" data-id="element-306">CARPINTERÍA PLEGABLE PRO</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-charcoal/80 font-medium mb-8" data-id="element-307">
            6 Tomos + 6 Bonos — Todos los proyectos — Todo resuelto.
          </motion.p>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="flex flex-wrap justify-center gap-4 text-sm md:text-base font-medium text-wood-medium" data-id="element-308">
            <span className="bg-white px-4 py-2 rounded-full shadow-sm border border-wood-light/20" data-id="element-309">
              +480 páginas
            </span>
            <span className="bg-white px-4 py-2 rounded-full shadow-sm border border-wood-light/20" data-id="element-310">
              30 modelos con planos
            </span>
            <span className="bg-white px-4 py-2 rounded-full shadow-sm border border-wood-light/20" data-id="element-311">
              48 checklists
            </span>
          </motion.div>
        </div>

        <div className="max-w-6xl mx-auto" data-id="element-312">
          <div className="text-center mb-12" data-id="element-313">
            <h3 className="text-3xl font-serif font-bold text-wood-dark mb-2" data-id="element-314">
              LOS 6 TOMOS
            </h3>
            <p className="text-wood-medium italic" data-id="element-315">
              Para carpinteros de todos los niveles
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16" data-id="element-316">
            {tomos.map((tomo, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white rounded-2xl p-8 shadow-warm border-t-4 border-amber hover:-translate-y-1 transition-transform duration-300" data-id="element-317">
                <div className="text-4xl mb-4" data-id="element-318">{tomo.icon}</div>
                <h4 className="text-xl font-bold text-wood-dark mb-2 leading-tight" data-id="element-319">
                  {tomo.title}
                </h4>
                <p className="text-sm text-amber-dark font-medium italic mb-6 pb-4 border-b border-wood-light/20" data-id="element-320">
                  {tomo.subtitle}
                </p>
                <ul className="space-y-3" data-id="element-321">
                  {tomo.items.map((item, i) => <li key={i} className="flex items-start text-sm text-charcoal/80" data-id="element-322">
                      <span className="mr-2 text-amber mt-0.5" data-id="element-323">•</span>
                      <span className={item.includes('Proyecto estrella') ? 'font-bold text-wood-dark' : ''} data-id="element-324">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-wood-dark text-cream rounded-2xl p-8 md:p-12 shadow-warm-lg wood-texture" data-id="element-325">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-amber mb-8 text-center" data-id="element-326">
              Cada tomo incluye:
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto" data-id="element-327">
              {features.map((feature, index) => <div key={index} className="flex items-start" data-id="element-328">
                  <CheckCircle2 className="w-6 h-6 text-amber mr-3 flex-shrink-0" data-id="element-329" />
                  <span className="text-cream-dark/90" data-id="element-330">{feature}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}